/**
 * @typedef {object} FeedPage
 * @property {import('@drama/contracts/drama').DramaT[]} items
 * @property {string} [next_cursor]
 */

/**
 * feed 域：刷剧分页（热度排序基础版，游标翻页）。
 * @param {ReturnType<import('../transport.js').createTransport>} transport
 */
export function createFeedApi(transport) {
  return {
    /**
     * @param {string} [cursor]
     * @returns {Promise<FeedPage>}
     */
    list(cursor) {
      return transport.request('GET', '/api/sk/feed', { query: { cursor } })
    },
  }
}
